import Vue from "vue";

const listeners = [];

const vm = new Vue({
	data: {
		categories: [],
		done: false,
		error: undefined,
		contactDetails: undefined,
		answers: undefined,
		email: undefined,
		results: undefined,
		token: undefined,
		contactFormCompany: {},
		contactFormPersonal: {},

		companyFields: {}, // These hold the response
		personalFields: {}
	},
	methods: {
		waitForResponse(cb) {
			if (this.done) {
				cb();
			}
			listeners.push(cb);
		},
		getCategoryById(id) {
			return this.categories.find(cat => cat.id === Number(id));
		},
		clearResponse() {
			this.answers = undefined;
			this.companyFields = {};
			this.personalFields = {};
			this.token = undefined;
			this.results = undefined;
			this.contactDetails = undefined;
		},
		loadSurvey(tenantName) {
			return fetch(`${process.env.API}/tenants/${tenantName}/surveys/latest`)
				.then(res => {
					if (!res.ok) throw new `Http error ${res.status}`();
					return res.json();
				})
				.then(
					res => {
						this.categories = res.categories;
						this.contactFormCompany["en"] =
							res.contact_en_organisation;
						this.contactFormPersonal["en"] =
							res.contact_en_personal;
						this.contactFormCompany["nl"] =
							res.contact_nl_organisation;
						this.contactFormPersonal["nl"] =
							res.contact_nl_personal;
					},
					err => {
						this.error = err;
						throw err;
					}
				)
				.then(() => {
					this.clearResponse();
					this.done = true;
					this.error = undefined;
					for (let i = 0; i < listeners.length; i++) {
						listeners[i]();
					}
					listeners.length = 0;
				});
		}
	}
});

export default vm;
